import { render, staticRenderFns } from "./x-radio-group.vue?vue&type=template&id=136472d9&scoped=true&"
import script from "./x-radio-group.vue?vue&type=script&lang=js&"
export * from "./x-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-group.vue?vue&type=style&index=0&id=136472d9&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136472d9",
  null
  
)

export default component.exports